import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Fade from "@mui/material/Fade";

const OptionalFormRow = (props) => {
    const [isShown, setShown] = useState(false);

    const shouldShowInput = () => {
        if (props.value) {
            return true;
        }
        if (isShown) {
            return true;
        }
        return false;
    }

    const showInput = () => {
        setShown(true);
    }

    const hideInput = () => {
        setShown(false)
        props.onHide()
    }

    if (shouldShowInput()) {
        return (
            <Fade in={true} timeout={500}>
                <div className="grid-x grid-margin-x form-row">
                    <div className="cell small-12 medium-3">
                        <label htmlFor="">{props.label}</label>
                    </div>
                    <div className="cell small-12 medium-9 optional-input">
                        { (props.collapsible) && (
                            <a className="optional-input-hide" onClick={hideInput}>
                                <i className="fa fa-minus-circle"></i>
                            </a>
                        )}
                        {props.children}
                        {props.errorMessage && (
                            <small className="error">{props.errorMessage}</small>
                        )}
                    </div>
                </div>
            </Fade>
        )
    } else {
        return (
            <div className="grid-x grid-margin-x form-row">
                <div className="cell small-12 medium-3"></div>
                <div className="cell small-12 medium-9 optional-input">
                    <a className="optional-input-show" onClick={showInput}>
                        + {props.label}
                    </a>
                </div>
            </div>
        )
    }
}

OptionalFormRow.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    errorMessage: PropTypes.string,
    collapsible: PropTypes.bool,
    onHide: PropTypes.func,
}

OptionalFormRow.defaultProps = {
    collapsible: false
}

export default OptionalFormRow;
